enum OnlineFormType {
  BlancoSweden = 'ULSE',
  BlancoNorway = 'ULNO',
  MortgageNorway = 'MONO',
}

export default OnlineFormType;
